module.exports = __webpack_public_path__ + "static/media/align-center.ebfe55e8.svg";